import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import BreadcrumbNav from '@src/business-components/breadcrumb-nav';
import TopMenu from '@src/business-components/top-menu';
import Official from '@src/business-components/official-community';
import Store from './store';
import BackgroundImage from '@src/components/background-image';
import ReturnBtn from '@src/business-components/return-btn';

const styles = require('./index.less');

const PageLayout = ({ children, store }) => {
  store.use();
  return (
    <div className={styles.pageLayout}>
      <TopMenu store={store.topMenuStore} />

      {store.isHideTopMenu ? (
        <div className="media-music-group-top-empty">
          <ReturnBtn store={store.returnBtnStore} />
        </div>
      ) : (
        <div className="media-music-group-top">
          <div className="media-music-group-4" data-name="顶图信息">
            <div className={cx(styles.leftTitle)}>
              <BackgroundImage src={require(`./images/${store.type}.png`)} />
            </div>
            <div className={styles.breadcrumbNav}>
              <BreadcrumbNav store={store.breadcrumbNavStore} />
            </div>
          </div>
        </div>
      )}

      {children}

      <Official store={store.officialStore} />
    </div>
  );
};

export default wrapStore(PageLayout, Store);
